import React, { useEffect, useState } from "react";
import Accordion from "@/components/common/faq/Accordion";
import Head from "next/head";

const CustomFAQ = ({
  faqData,
}: {
  faqData: {
    id: number;
    question: string;
    ans: string;
  }[];
}) => {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const faqSchema = {
    "@context": "https://schema.org",
    name: "FAQ",
    "@type": "FAQPage",
    mainEntity: faqData.map(
      (faq: { id: number; question: string; ans: string }) => {
        return {
          "@type": "Question",
          name: "FAQ Question",
          text: faq.question,
          acceptedAnswer: {
            "@type": "Answer",
            name: "FAQ Answer",
            text: faq.ans,
          },
        };
      }
    ),
  };
  return (
    <section id="faq" className="bg-white px-[13px] py-[60px] my-[40px] ">
      <Head>
        {typeof window !== "undefined" && (
          <script type="application/ld+json">
            {JSON.stringify(faqSchema)}
          </script>
        )}
      </Head>
      <div className="mx-auto max-w-7xl">
        <h2 className="font-bold text-base lg:text-[40px] mb-[22px] lg:mb-[40px] text-my-dark-blue">
          Frequently asked questions
        </h2>
        {faqData.map((faq: { id: number; question: string; ans: string }) => {
          return (
              <Accordion
                key={faq.id}
                faq={faq}
                setFaq={setOpenFaq}
                openFaq={openFaq}
              />
          );
        })}
      </div>
    </section>
  );
};

export default CustomFAQ;
